import type { TreeDesignTokens, TreeTokenSections } from '@primeuix/themes/types/tree';

export const root: TreeTokenSections.Root = {
    background: 'transparent',
    color: '{content.color}',
    padding: '1rem',
    gap: '0.125rem',
    indent: '1rem',
    transitionDuration: '{transitionDuration}'
};

export const node: TreeTokenSections.Node = {
    padding: '0.5rem',
    borderRadius: '{content.borderRadius}',
    hoverBackground: '{content.hoverBackground}',
    selectedBackground: '{primary.color}',
    color: '{content.color}',
    hoverColor: '{content.hoverColor}',
    selectedColor: '{primary.contrastColor}',
    focusRing: {
        width: '{focusRing.width}',
        style: '{focusRing.style}',
        offset: '{focusRing.offset}'
    },
    gap: '0.5rem'
};

export const nodeIcon: TreeTokenSections.NodeIcon = {
    color: '{content.color}',
    hoverColor: '{primary.color}',
    selectedColor: '{primary.contrastColor}'
};

export const nodeToggleButton: TreeTokenSections.NodeToggleButton = {
    borderRadius: '{extend.borderRadius.rounded}',
    size: '1.75rem',
    hoverBackground: '{content.hoverBackground}',
    selectedHoverBackground: '{primary.hoverColor}',
    color: '{content.color}',
    hoverColor: '{content.hoverColor}',
    selectedHoverColor: '{primary.contrastColor}',
    focusRing: {
        width: '{focusRing.width}',
        style: '{focusRing.style}',
        offset: '{focusRing.offset}'
    }
};

export const loadingIcon: TreeTokenSections.LoadingIcon = {
    size: '1rem'
};

export const filter: TreeTokenSections.Filter = {
    margin: '0 0 0.75rem 0'
};

export default {
    root,
    node,
    nodeIcon,
    nodeToggleButton,
    loadingIcon,
    filter
} satisfies TreeDesignTokens;
